/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { QuoteTestExecution } from "./QuoteTestExecution";
import {
  QuoteTestExecutionFromJSON,
  QuoteTestExecutionFromJSONTyped,
  QuoteTestExecutionToJSON,
  QuoteTestExecutionToJSONTyped,
} from "./QuoteTestExecution";
import type { QuoteTestGroup } from "./QuoteTestGroup";
import {
  QuoteTestGroupFromJSON,
  QuoteTestGroupFromJSONTyped,
  QuoteTestGroupToJSON,
  QuoteTestGroupToJSONTyped,
} from "./QuoteTestGroup";
import type { QuoteTestExpectation } from "./QuoteTestExpectation";
import {
  QuoteTestExpectationFromJSON,
  QuoteTestExpectationFromJSONTyped,
  QuoteTestExpectationToJSON,
  QuoteTestExpectationToJSONTyped,
} from "./QuoteTestExpectation";
import type { QuoteTestExecutionComment } from "./QuoteTestExecutionComment";
import {
  QuoteTestExecutionCommentFromJSON,
  QuoteTestExecutionCommentFromJSONTyped,
  QuoteTestExecutionCommentToJSON,
  QuoteTestExecutionCommentToJSONTyped,
} from "./QuoteTestExecutionComment";
import type { QuoteTestScenario } from "./QuoteTestScenario";
import {
  QuoteTestScenarioFromJSON,
  QuoteTestScenarioFromJSONTyped,
  QuoteTestScenarioToJSON,
  QuoteTestScenarioToJSONTyped,
} from "./QuoteTestScenario";

/**
 *
 * @export
 * @interface ImportQuoteGroupData
 */
export interface ImportQuoteGroupData {
  /**
   *
   * @type {QuoteTestGroup}
   * @memberof ImportQuoteGroupData
   */
  group: QuoteTestGroup;
  /**
   *
   * @type {{ [key: string]: Array<QuoteTestExpectation>; }}
   * @memberof ImportQuoteGroupData
   */
  groupExpectation: { [key: string]: Array<QuoteTestExpectation> };
  /**
   *
   * @type {Array<QuoteTestScenario>}
   * @memberof ImportQuoteGroupData
   */
  scenarios: Array<QuoteTestScenario>;
  /**
   *
   * @type {{ [key: string]: Array<QuoteTestExpectation>; }}
   * @memberof ImportQuoteGroupData
   */
  scenarioExpectations: { [key: string]: Array<QuoteTestExpectation> };
  /**
   *
   * @type {Array<QuoteTestExecution>}
   * @memberof ImportQuoteGroupData
   */
  executions: Array<QuoteTestExecution>;
  /**
   *
   * @type {Array<QuoteTestExecutionComment>}
   * @memberof ImportQuoteGroupData
   */
  comments: Array<QuoteTestExecutionComment>;
}

/**
 * Check if a given object implements the ImportQuoteGroupData interface.
 */
export function instanceOfImportQuoteGroupData(
  value: object,
): value is ImportQuoteGroupData {
  if (!("group" in value) || value["group"] === undefined) return false;
  if (!("groupExpectation" in value) || value["groupExpectation"] === undefined)
    return false;
  if (!("scenarios" in value) || value["scenarios"] === undefined) return false;
  if (
    !("scenarioExpectations" in value) ||
    value["scenarioExpectations"] === undefined
  )
    return false;
  if (!("executions" in value) || value["executions"] === undefined)
    return false;
  if (!("comments" in value) || value["comments"] === undefined) return false;
  return true;
}

export function ImportQuoteGroupDataFromJSON(json: any): ImportQuoteGroupData {
  return ImportQuoteGroupDataFromJSONTyped(json, false);
}

export function ImportQuoteGroupDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ImportQuoteGroupData {
  if (json == null) {
    return json;
  }
  return {
    group: QuoteTestGroupFromJSON(json["group"]),
    groupExpectation: json["groupExpectation"],
    scenarios: (json["scenarios"] as Array<any>).map(QuoteTestScenarioFromJSON),
    scenarioExpectations: json["scenarioExpectations"],
    executions: (json["executions"] as Array<any>).map(
      QuoteTestExecutionFromJSON,
    ),
    comments: (json["comments"] as Array<any>).map(
      QuoteTestExecutionCommentFromJSON,
    ),
  };
}

export function ImportQuoteGroupDataToJSON(json: any): ImportQuoteGroupData {
  return ImportQuoteGroupDataToJSONTyped(json, false);
}

export function ImportQuoteGroupDataToJSONTyped(
  value?: ImportQuoteGroupData | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    group: QuoteTestGroupToJSON(value["group"]),
    groupExpectation: value["groupExpectation"],
    scenarios: (value["scenarios"] as Array<any>).map(QuoteTestScenarioToJSON),
    scenarioExpectations: value["scenarioExpectations"],
    executions: (value["executions"] as Array<any>).map(
      QuoteTestExecutionToJSON,
    ),
    comments: (value["comments"] as Array<any>).map(
      QuoteTestExecutionCommentToJSON,
    ),
  };
}
